import React from "react";
import "./About.css";

const Missionsection = () => {
    return (
        <>
             {/* Mission & Vision */}
            <section className="rts-mission">
                <div className="containerabout">
                    <div className="rt-center mb-30">
                        <h2 className="rts-section-title">Our Mission and Vision</h2>
                    </div>

                    <div className="rts-timeline-section">
                        <div className="rts-timeline-content">
                            <div className="left-side">
                                <TimelineItem
                                    title="Mission"
                                    text="At Techno India, our unwavering dedication to excellence is a core value that transcends boundaries and serves as our greatest strength. We are steadfast in our commitment to continuously evolve and adapt to the ever-changing needs of the times. With our abundant resources and unwavering commitment, we relentlessly pursue perfection today while actively working towards a brighter future."
                                    img="images/about/mission-1.jpg"
                                />
                                <TimelineItem
                                    title="Excellence"
                                    text="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
                                    img="images/about/mission-2.jpg"
                                />
                            </div>

                            <div className="separator"></div>

                            <div className="right-side">
                                <TimelineItem
                                    title="Vision"
                                    text="Techno India is deeply dedicated to revolutionizing the boundaries of possibilities for individuals eager to acquire knowledge. We empower those with an entrepreneurial drive to foster innovation, possess the compassion to utilize education for the betterment of humanity, and possess the foresight to recognize the boundless potential of technology. As a leading institution in the education sector, particularly in engineering, Techno India provides a nurturing environment that encourages students to explore their potential and achieve excellence."
                                    img="images/about/mission-3.jpg"
                                />
                                <TimelineItem
                                    title="Academic Excellence"
                                    text="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
                                    img="images/about/mission-4.jpg"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            
            
        </>
    );
};

/* Reusable Components */


const TimelineItem = ({ title, text, img }) => (
    <div className="single-timeline-item">
        <h5>{title}</h5>
        <p>{text}</p>
        <img src={img} alt={title} />
    </div>
);

export default Missionsection;
